import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

interface IconDefinition {
  /** assignment for MatIcon.svgIcon */
  name: string;
  /**
   * path to the SVG file.
   * requirements:
   *  1. must be SVG.
   *  2. must be in assets/mat-icons root directory or any subdirectory within.
   */
  path: `assets/mat-icons/${string}.svg`;
}

/**
 * Global service for registering custom SVG files with Angular Material for use with MatIcon.
 */
@Injectable({ providedIn: 'root' })
export class AppIconRegistryService {
  private domSanitizer = inject(DomSanitizer);
  private matIconRegistry = inject(MatIconRegistry);

  private hasBeenInitialized = false;

  /** start the SVG registration process. guarded against multiple executions in a single app lifetime. */
  start(): void {
    if (!this.hasBeenInitialized) {
      this.icons.forEach((icon) => {
        this.matIconRegistry.addSvgIcon(icon.name, this.domSanitizer.bypassSecurityTrustResourceUrl(icon.path));
      });
      this.hasBeenInitialized = true;
    }
  }

  /**
   * list of all icons. try to keep the structure in alignment with the actual folder :)
   * helpful to have Amazon Q check this when changed
   */
  private icons: IconDefinition[] = [
    { name: 'chevron_right', path: 'assets/mat-icons/chevron_right.svg' },
    { name: 'close', path: 'assets/mat-icons/close.svg' },
    { name: 'genesys_g', path: 'assets/mat-icons/genesys_g.svg' },
    { name: 'warning', path: 'assets/mat-icons/warning.svg' },
    { name: 'error', path: 'assets/mat-icons/error.svg' },
  ];
}
